import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { Checkbox } from '@/components/ui/checkbox';

export const CheckboxController = <T extends FieldValues>({
  name,
  methods,
  label,
  wrapperClassName,
}: {
  label: string;
  name: Path<T>;
  methods: UseFormReturn<T>;
  wrapperClassName?: string;
}) => {
  return (
    <Controller
      {...methods}
      name={name}
      render={({ field: { value, onChange, ...field }, formState: { errors } }) => (
        <Checkbox
          checked={value}
          label={label}
          error={Boolean(errors[name]?.message)}
          wrapperClassName={wrapperClassName}
          onCheckedChange={(checked) => onChange(checked)}
          {...field}
        />
      )}
    />
  );
};
